import config from "@/config/config";
import { headers } from "./auth.headers";
import { formatQueryString } from "@/helpers/query-string";
import { Product } from "@/domain/product.model";
import { IPaginateVueTable } from "@/interfaces/IPaginateVueTable";
import httpClient from "@/helpers/http-client";

export default class ProductService {
  private static urlApiBase = config.url_api_base;

  static insert = (data: Product): Promise<Product> => {
    return httpClient
      .request<Product>({
        url: `${this.urlApiBase}/product`,
        method: "POST",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static update = (data: Product): Promise<Product> => {
    return httpClient
      .request<Product>({
        url: `${this.urlApiBase}/product/${data.id}`,
        method: "PATCH",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static get = (id: string): Promise<Product> => {
    const url = `${this.urlApiBase}/product/${id}`;

    return httpClient
      .request<Product>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static list = (
    offset?: number,
    limit?: number,
    order?: string,
    sort?: string,
    filter?: Record<string, unknown>,
  ): Promise<IPaginateVueTable<Product>> => {
    const query = formatQueryString(offset, limit, order, sort, filter, true);
    const url = `${this.urlApiBase}/product${query}`;

    return httpClient
      .request<IPaginateVueTable<Product>>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static listActive = (): Promise<Product[]> => {
    const url = `${this.urlApiBase}/product/list-active`;

    return httpClient
      .request<Product[]>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static delete = (id: string): Promise<Product> => {
    const url = `${this.urlApiBase}/product/${id}`;

    return httpClient
      .request<Product>({
        url,
        method: "DELETE",
        headers: headers(),
      })
      .then(result => result?.body);
  };
}
